import {
    SxmTypePaymentMethod,
    SxmTypePaymentType,
} from '@sxm-de/dev-kits/web-sdk/types';
import { BillingSummary } from '@sxm-de/dev-kits/microservices-sdk/types';
import { mapSmsCreditCardToCreditCard } from './map-sms-credit-card-to-credit-card';

export function mapSmsBillingSummaryToPaymentMethod(
    billingSummary: BillingSummary,
): SxmTypePaymentMethod | null {
    if (!billingSummary?.paymentType) {
        return null;
    }
    return {
        type: billingSummary.paymentType as SxmTypePaymentType,
        creditCard: mapSmsCreditCardToCreditCard(billingSummary?.creditCard),
    };
}
